import { useEffect, useState } from 'react';

const DDI_OPTIONS = [
  { code: '+55',  flag: '🇧🇷', label: 'BR' },
  { code: '+351', flag: '🇵🇹', label: 'PT' },
  { code: '+1',   flag: '🇺🇸', label: 'US' },
  { code: '+54',  flag: '🇦🇷', label: 'AR' },
  { code: '+34',  flag: '🇪🇸', label: 'ES' },
  { code: '+33',  flag: '🇫🇷', label: 'FR' },
  { code: '+44',  flag: '🇬🇧', label: 'GB' },
  { code: '+52',  flag: '🇲🇽', label: 'MX' },
  { code: '+56',  flag: '🇨🇱', label: 'CL' },
  { code: '+57',  flag: '🇨🇴', label: 'CO' },
  { code: '+598', flag: '🇺🇾', label: 'UY' },
  { code: '+51',  flag: '🇵🇪', label: 'PE' },
  { code: '+593', flag: '🇪🇨', label: 'EC' },
  { code: '+595', flag: '🇵🇾', label: 'PY' },
  { code: '+591', flag: '🇧🇴', label: 'BO' },
  { code: '+58',  flag: '🇻🇪', label: 'VE' },
  { code: '+49',  flag: '🇩🇪', label: 'DE' },
  { code: '+39',  flag: '🇮🇹', label: 'IT' },
  { code: '+81',  flag: '🇯🇵', label: 'JP' },
  { code: '+86',  flag: '🇨🇳', label: 'CN' },
];

function parseParts(value: string): { ddi: string; number: string } {
  if (!value) return { ddi: '+55', number: '' };
  const trimmed = value.trim();
  for (const opt of DDI_OPTIONS) {
    if (trimmed.startsWith(opt.code + ' ')) {
      return { ddi: opt.code, number: trimmed.slice(opt.code.length + 1) };
    }
    if (trimmed.startsWith(opt.code)) {
      return { ddi: opt.code, number: trimmed.slice(opt.code.length).trim() };
    }
  }
  return { ddi: '+55', number: trimmed };
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  style?: React.CSSProperties;
}

export function PhoneInput({ value, onChange, placeholder = '11 99999-9999', style }: Props) {
  const parts = parseParts(value);
  const [ddi, setDdi] = useState(parts.ddi);
  const [number, setNumber] = useState(parts.number);

  useEffect(() => {
    const p = parseParts(value);
    setDdi(p.ddi);
    setNumber(p.number);
  }, [value]);

  function handleDdi(newDdi: string) {
    setDdi(newDdi);
    onChange(number ? `${newDdi} ${number}` : '');
  }

  function handleNumber(n: string) {
    setNumber(n);
    onChange(n ? `${ddi} ${n}` : '');
  }

  return (
    <div style={{ display: 'flex', gap: '0.4rem', ...style }}>
      <select
        value={ddi}
        onChange={e => handleDdi(e.target.value)}
        className="form-input"
        style={{ flexShrink: 0, width: '5.5rem', padding: '0.35rem 0.3rem', fontSize: 'var(--text-label)' }}
        aria-label="DDI (código de país)"
      >
        {DDI_OPTIONS.map(opt => (
          <option key={opt.code} value={opt.code}>{opt.flag} {opt.code}</option>
        ))}
      </select>
      <input
        type="tel"
        className="form-input"
        value={number}
        onChange={e => handleNumber(e.target.value)}
        placeholder={placeholder}
        style={{ flex: 1 }}
      />
    </div>
  );
}
